// @ts-nocheck
import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g fill="currentColor" clipPath="url(#a)">
                <path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z" />
                <path d="M11.28 8.938c0 .852-.647 1.54-1.662 1.54s-1.62-.69-1.6-1.54c-.02-.892.629-1.56 1.621-1.56s1.62.668 1.642 1.56ZM8.1 21.605v-9.912h3.08v9.912H8.1ZM13.652 14.856c0-1.237-.04-2.29-.082-3.163h2.676l.142 1.358h.06c.406-.629 1.419-1.582 3.06-1.582 2.027 0 3.548 1.337 3.548 4.258v5.878h-3.081v-5.492c0-1.276-.445-2.147-1.56-2.147-.853 0-1.358.587-1.561 1.155-.081.182-.121.487-.121.77v5.716h-3.081v-6.751Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Linkedin);
